export { default as theme } from 'prismjs/themes/prism-tomorrow.css';
